import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "data-analysis"
    }}>{`Data Analysis`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Many PDF documents contain data rich reports such as SEC filings, clinical studies, and government reports. These reports include data in many different forms – text blocks, tables, figures, and charts - which companies want to analyze. However, in their native PDF form, individual reports are optimized for human consumption, not comprehensive analysis. To accelerate the pace of analysis and insight generation, organizations want to extract data from PDF reports programmatically and move it to a more suitable format for analysis. This use case includes both a Basic and an Advanced approach to data analysis.`}</p>
    <p>{`Basic: Sometimes companies simply want to export data from PDFs into spreadsheet applications so end users can analyze the data. The Adobe PDF Services API is ideal for these use cases since it converts PDF documents into Microsoft Excel.`}</p>
    <p>{`Advanced: Other times, there are cases where hundreds or thousands of reports need to be analyzed in aggregate making it impractical to do manually. The Adobe PDF Extract API enables the content published in reports, as well as other rich document types, to be extracted in context and efficiently analyzed by machine learning algorithms to expose new, deeper insights.`}</p>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Adobe PDF Extract API`}</a></li>
    </ul>
    <h3 {...{
      "id": "basic-scenario"
    }}>{`Basic Scenario`}</h3>
    <p>{`A company has several years of archived financial reports that have been saved in different formats. Some of the files are also paper documents, so data is difficult to use without significant manual intervention. Data analysts want to be able to select reports from a repository, no matter its original format, and analyze and perform calculations on them. After completing their analysis, they want to create new reports to share with executives in PDF format.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Scan paper documents to PDF format to create a digital repository`}</li>
      <li parentName="ol">{`Create an interface that presents select files for a data analyst to choose from`}</li>
      <li parentName="ol">{`Export selected PDF documents to XLS using Adobe PDF Services API export operation`}</li>
      <li parentName="ol">{`Perform calculations on multiple XLS files for new insights and store in a database`}</li>
      <li parentName="ol">{`Using Adobe PDF Services API, recreate charts and data in PDF format as a report or whitepaper`}</li>
      <li parentName="ol">{`Display new documents within the application with Adobe PDF Embed API`}</li>
    </ol>
    <h3 {...{
      "id": "advanced-scenario"
    }}>{`Advanced Scenario`}</h3>
    <p>{`A company wants to extract information from large numbers of financial reports and filings in order to create a database that can be used by venture capitalists, private equity firms, and M&A teams to more effectively identify and assess investment opportunities in targeted markets and industries.`}</p>
    <h3 {...{
      "id": "building-this-solution-1"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Pass a PDF to the Adobe PDF Extract API to retrieve tabular information`}</li>
      <li parentName="ol">{`Loop over the tabular data and insert them into a database table`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      